module.exports = __webpack_public_path__ + "static/gm-3-838d40a504962369525cc8453ddeaccf.jpg";